import BaseDropdown from "@/components/baseDropdown/baseDropdown.vue";
import { createNamespacedHelpers } from "vuex";

const { mapState: categoriesState } = createNamespacedHelpers("categories");

export default {
	components: { BaseDropdown },

	props: {
		value: {
			type: [String, Number, Object],
			default: () => ({
				id: null,
				en: "items.all_categories",
				de: "items.all_categories",
				fr: "items.all_categories",
			}),
		},
		limitCategories: {
			type: Array,
			required: false,
		},
	},

	model: {
		prop: "value",
		event: "change",
	},

	watch: {
		selectedCategory(selectedCategory) {
			this.$emit("change", selectedCategory);
		},
	},

	data() {
		return { selectedCategory: null };
	},

	computed: {
		dropdownCategories,

		...categoriesState(["categories"]),
	},

	created() {
		this.init();
	},

	methods: { init },
};

async function init() {
	this.selectedCategory = { ...this.value };
}

function dropdownCategories() {
	const categoriesToShow = this.limitCategories
		? this.categories.filter((item) => this.limitCategories.includes(item.id))
		: this.categories;

	return [
		{
			id: null,
			en: "items.all_categories",
			de: "items.all_categories",
			fr: "items.all_categories",
		},
		...categoriesToShow.map((item) => ({
			...item,

			/*
			 * move translations key one level up in the object,
			 * so they are easier to access in the vue <template>
			 */
			...item.translations,
		})),
	];
}
